import { render, staticRenderFns } from "./LearnSpeed.vue?vue&type=template&id=b6a8605a&scoped=true&"
import script from "./LearnSpeed.vue?vue&type=script&lang=js&"
export * from "./LearnSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a8605a",
  null
  
)

export default component.exports